/**
 * Главный компонент приложения: настройка React Query и роутера
 * Подключает глобальные стили Tailwind CSS
 * Дата: 27.12.2025 - Добавлен ToastContainer для TODO-007
 */
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { ToastContainer } from './components/ui/ToastContainer';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ToastContainer />
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;

